module.exports = __webpack_public_path__ + "static/media/TJ.2cb1525b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TJ.svg
// module id = 373
// module chunks = 0